import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

// const header = [
//   { label: 'S.N', value: 'id' },
//   {
//     label: 'Transport Type',
//     value: 'transportType',
//   },
//   {
//     label: 'C02 Emission Per Km',
//     value: 'id',
//   },
//   {
//     label: 'Basis',
//     value: 'basis',
//   },
//   /*  {
//     action: ['edit'],
//   }, */
// ]




const header = [
  { label: 'S.N', value: 'id' },
  {
    label: 'Truck Type',
    value: 'description',
  },
  {
    label: 'Fuel Efficiency',
    value: 'fuelEfficiencyt',
  },
  {
    label: 'Co2 Emissions',
    value: 'co2Emissions',
  },
  {
    label: 'CH4 Emissions',
    value: 'ch4Emissionst',
  },
  {
    label: 'N2o Emissions',
    value: 'n2oEmissionst',
  },
  /*  {
    action: ['edit'],
  }, */
]



const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
